import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { FC } from 'react'

import { RepairOrderAttachmentEntry } from '../../../sdk'

interface Props {
  entry: RepairOrderAttachmentEntry
  handleClose: () => void
  handleDelete: () => void
}

export const DeleteRepairOrderAttachmentDialog: FC<Props> = ({
  entry,
  handleClose,
  handleDelete
}) => {
  const url = new URL(entry.attachmentUrl!)
  const pathSegments = url.pathname.split('/')
  const fileName = pathSegments[pathSegments.length - 1]

  return (
    <Dialog open={true} onClose={handleClose} fullWidth maxWidth={'sm'}>
      <DialogTitle>Delete Attachment</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to delete {fileName}?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant={'text'} onClick={handleDelete} color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
